import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegistrationRoutingModule } from './registration-routing.module';
import { SharedModule } from '../shared/shared.module';
import { CreateAccountComponent } from './create-account/create-account.component';
import { RegistrationComponent } from './registration.component';
import { CodeVerificationComponent } from './code-verification/code-verification.component';
import { EmailVerificationComponent } from './email-verification/email-verification.component';
import { MaterialModule } from '../shared/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EheMeRedirectModalComponent } from '../account/ehe-me-redirect-modal/ehe-me-redirect-modal.component';
import { BaseCodeVerificationComponent } from './base-code-verification/base-code-verification.component';
import { RegComponent } from './registration-base/registration-base.component';
import { BaseEmailVerificationComponent } from './base-email-verification/base-email-verification.component';
import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';

@NgModule({
	imports: [
		CommonModule,
		RegistrationRoutingModule,
		SharedModule,
		MaterialModule,
		FormsModule,
		ReactiveFormsModule,
		MatPasswordStrengthModule,
	],
	declarations: [
		CreateAccountComponent,
		RegistrationComponent,
		CodeVerificationComponent,
		EmailVerificationComponent,
		EheMeRedirectModalComponent,
		RegComponent,
		BaseCodeVerificationComponent,
		BaseEmailVerificationComponent,
	],
})
export class RegistrationModule {}
